import { useState } from 'react';
import { QrCode } from 'lucide-react';
import { QrImage } from '@/components/common/qr-image';

/** Build the guest-join URL a scanner opens to request access to a mission. */
function joinUrl(joinCode: string): string {
  return `${window.location.origin}/join?code=${encodeURIComponent(joinCode)}`;
}

/**
 * Mission QR: encodes the guest-join URL for a mission's join code. A scanner
 * opens the link to *request* to join — access is granted by the mission leader
 * (admin approval), and approved scanners get a view-only session. The QR only
 * carries the request link; it grants nothing on its own.
 */
export function MissionQr({ joinCode }: { joinCode: string }): React.JSX.Element | null {
  const [open, setOpen] = useState(false);
  if (!joinCode) return null;

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="flex items-center justify-center gap-1.5 rounded border border-white/10 px-3 py-2 text-xs text-foreground hover:bg-white/[0.06]"
      >
        <QrCode className="h-3.5 w-3.5" /> Show join QR
      </button>
    );
  }

  return (
    <div className="flex flex-col items-center gap-2 rounded-md border border-echo-border bg-white/[0.03] p-3">
      <QrImage value={joinUrl(joinCode)} size={176} className="rounded bg-white p-1.5" />
      <p className="text-center text-[11px] text-muted-foreground">
        Scan to request to join as a guest. The mission leader approves access.
      </p>
      <p className="font-mono text-xs tracking-widest text-foreground">{joinCode}</p>
      <button type="button" onClick={() => setOpen(false)} className="text-[11px] text-muted-foreground hover:text-foreground">
        Hide
      </button>
    </div>
  );
}
